/* Imports */
import React from "react"
import { Font, Section } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

const SectionPage = () => {
    const items = [
        {
            content: (
                <Section gap="large">
                    <Font.H4>Title</Font.H4>
                    <Font.P>Content</Font.P>
                </Section>
            ),
            code: '<Section gap="large">\n    \n</Section>',
        },
    ]

    const propsItems = [
        {
            name: "gap",
            type: "String",
            example: "medium",
            possible: '"large" | "medium" | "small"',
            default: "large",
        },
        {
            name: "div",
            type: "Boolean",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default SectionPage
